import VideoJsAdapter from "@javascripts/adapters/videojs_adapter";

export default class ProgressControl extends VideoJsAdapter.getComponent('ProgressControl') {
  constructor(player, options = {}){
    super(player, options);

    this.listenClick();
  }

  hide(){
    this.addClass("vjs-progress-control--hidden");
  }

  show(){
    this.removeClass("vjs-progress-control--hidden");
  }

  listenClick(){
    const seekbar = this.getChild('seekBar')
    if (seekbar) {
      seekbar.on(['mousedown', 'touchstart'], () => {
        this.player().trigger({
          type: 'vp-before-seeked',
          action: 'seekbar'
        });
      })
    }
  }
}

VideoJsAdapter.registerComponent('ProgressControl', ProgressControl);
